module.exports = "<div class=\"col-sm-2\"><app-sidebar-cta></app-sidebar-cta></div><div class=\"col-sm-8\"><app-alerts></app-alerts><router-outlet></router-outlet></div><div class=\"col-sm-2\"><app-form-submission></app-form-submission></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/route/private/admin-domain/admin-domain.component.pug
// module id = 1100
// module chunks = 1